import { render, staticRenderFns } from "./SearchFilterTokens-v2.vue?vue&type=template&id=e6b0c53e&scoped=true&"
import script from "./SearchFilterTokens-v2.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens-v2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6b0c53e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e6b0c53e')) {
      api.createRecord('e6b0c53e', component.options)
    } else {
      api.reload('e6b0c53e', component.options)
    }
    module.hot.accept("./SearchFilterTokens-v2.vue?vue&type=template&id=e6b0c53e&scoped=true&", function () {
      api.rerender('e6b0c53e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2ItzJVaOR4L5i/JS/comp/SearchFilterTokens-v2.vue"
export default component.exports